var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "watchPhoneNumber" },
    [
      _vm.copyPhoneAreaCode && _vm.value && !_vm.isSave
        ? _c("div", [_vm._v(" (+" + _vm._s(_vm.copyPhoneAreaCode) + ")   ")])
        : _vm._e(),
      !_vm.isSave
        ? _c("div", [
            _c("span", { staticClass: "phoneNumber" }, [
              _vm._v(" " + _vm._s(_vm.newValue) + " "),
            ]),
            !_vm.isReal && _vm.newValue
              ? _c("i", {
                  staticClass: "pointer",
                  class: _vm.loading ? "el-icon-loading" : "el-icon-view",
                  on: { click: _vm.onClick },
                })
              : _vm._e(),
          ])
        : _c(
            "el-input",
            {
              staticStyle: { width: "270px" },
              attrs: {
                size: "small",
                maxlength: _vm.phoneMaxlength(_vm.newPhoneAreaCode),
                clearable: "",
              },
              model: {
                value: _vm.newPhone,
                callback: function ($$v) {
                  _vm.newPhone = $$v
                },
                expression: "newPhone",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: {
                    slot: "prepend",
                    filterable: "",
                    placeholder: "请选择",
                  },
                  slot: "prepend",
                  model: {
                    value: _vm.newPhoneAreaCode,
                    callback: function ($$v) {
                      _vm.newPhoneAreaCode = $$v
                    },
                    expression: "newPhoneAreaCode",
                  },
                },
                _vm._l(_vm.smsAreaList, function (group) {
                  return _c(
                    "el-option-group",
                    {
                      key: group.label,
                      attrs: { filterable: "", label: group.label },
                    },
                    _vm._l(group.options, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.areaCode,
                          attrs: {
                            label: `+${item.areaCode} ${item.areaChineseName}`,
                            value: item.areaCode,
                          },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.areaChineseName)),
                          ]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#8492a6",
                                "font-size": "13px",
                              },
                            },
                            [_vm._v("+" + _vm._s(item.areaCode))]
                          ),
                        ]
                      )
                    }),
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
      _vm.setPhone && _vm.phoneAuthority && !_vm.isSave
        ? _c("i", {
            directives: [
              {
                name: "permission",
                rawName: "v-permission",
                value: [_vm.phoneAuthority, _vm.permsList],
                expression: "[phoneAuthority, permsList]",
              },
            ],
            staticClass: "el-icon-edit pointer c_0F71FF edit",
            on: { click: _vm.handleEditPhone },
          })
        : _vm._e(),
      _vm.setPhone && !_vm.phoneAuthority && !_vm.isSave
        ? _c("i", {
            staticClass: "el-icon-edit pointer c_0F71FF edit",
            on: { click: _vm.handleEditPhone },
          })
        : _vm._e(),
      _c("div", [
        _vm.setPhone && _vm.isSave
          ? _c("div", { staticClass: "edit", on: { click: _vm.handleSave } }, [
              _vm._v("保存"),
            ])
          : _vm._e(),
        _vm.setPhone && _vm.isSave
          ? _c(
              "div",
              {
                staticClass: "edit",
                on: {
                  click: function ($event) {
                    _vm.isSave = false
                  },
                },
              },
              [_vm._v(" 取消 ")]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }